module.exports = __webpack_public_path__ + "static/media/client18.07ab5689.webp";